import { InteractiveContainer } from "@jugl-web/ui-components";
import { cx, useTranslations } from "@jugl-web/utils";
import { Menu, MenuItem } from "@jugl-web/ui-components/cross-platform/Menu";
import { useState } from "react";
import { InvoiceTaxRow } from "@web-src/modules/invoices/types";
import { ReactComponent as SettingsIcon } from "./assets/settings.svg";
import { TaxFieldDialog } from "../TaxFieldDialog";

type TaxFieldActionsProps = {
  item: InvoiceTaxRow;
  onEdit: (field: InvoiceTaxRow) => void;
  onRemove: (name: string) => void;
  currency: string;
};

export const TaxFieldActions = ({
  item,
  onEdit,
  onRemove,
  currency,
}: TaxFieldActionsProps) => {
  const { t } = useTranslations();

  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const removeField = () => {
    onRemove(item.id);
  };

  const sections: MenuItem<unknown>[][] = [
    [
      {
        id: "1",
        label: t({
          defaultMessage: "Edit Tax",
          id: "invoices.settings.businessInformation.taxSettings.editTax",
        }),
        labelClassName: "mt-1",
        onSelect: (_, close) => {
          setIsDialogOpen(true);
          close();
        },
      },
      {
        id: "2",
        label: t({
          defaultMessage: "Delete Tax",
          id: "invoices.settings.businessInformation.taxSettings.deleteTax",
        }),
        labelClassName: "text-tertiary-800 mb-1",
        onSelect: (_, close) => {
          removeField();
          close();
        },
      },
    ],
  ];

  return (
    <>
      <Menu
        placement="right-start"
        sections={sections}
        renderTrigger={({ Trigger, triggerRef, isOpen }) => (
          <Trigger
            as={InteractiveContainer}
            ref={triggerRef}
            className={cx(
              "mx-auto flex h-6 w-6 items-center justify-center rounded-md transition-colors duration-150",
              isOpen && "bg-grey-200"
            )}
          >
            <SettingsIcon />
          </Trigger>
        )}
      />

      <TaxFieldDialog
        key={`${item.name}-${item.percentage}`}
        isDialogOpen={isDialogOpen}
        onClose={() => setIsDialogOpen(false)}
        initialField={item}
        onSubmit={(newData) => {
          onEdit(newData);
        }}
        currency={currency}
      />
    </>
  );
};
